import { render, staticRenderFns } from "./ObserveTableMenu.vue?vue&type=template&id=eba06c3e&"
import script from "./ObserveTableMenu.vue?vue&type=script&lang=js&"
export * from "./ObserveTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports